var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['user-layout-wrapper'],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"container"},[_vm._m(0),_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"desc",staticStyle:{"font-size":"22px","font-weight":"500"}},[_vm._v(" 文化遗产资源管理库管理系统 ")])])
}]

export { render, staticRenderFns }